:host {
  display: block;
}

.business-lines {
  margin: 0;
  padding: 0;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}

@media screen and (max-width: 979px) {
  .business-lines {
    display: flex;
    flex-direction: column;
    max-width: 100%;
  }
}

@media screen and (min-width: 980px) {
  .business-lines {
    box-sizing: border-box;
    position: relative;
    display: block;
    background-color: #ffffff;
    margin: 0 auto 10px;
  }

  .business-lines *,
.business-lines *::before,
.business-lines *::after {
    box-sizing: inherit;
  }
}

.business-lines--view {
  display: flex;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .business-lines__item {
    display: block;
    box-sizing: border-box;
    width: 197px;
    height: 128px;
  }
}

.business-lines__button {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  display: flex;
  width: 100%;
  background-color: #ffffff;
  font-size: 14px;
  margin: 0;
}

:host(:not([dir="rtl"])) .business-lines__button {
  text-align: left;
}

:host([dir="rtl"]) .business-lines__button {
  text-align: right;
}

@media screen and (min-width: 980px) {
  .business-lines__button {
    flex-direction: column;
    align-items: center;
    height: 100%;
  }

  :host(:not([dir="rtl"])) .business-lines__button {
    border-left: 1px solid #e6e6e6;
  }

  :host([dir="rtl"]) .business-lines__button {
    border-right: 1px solid #e6e6e6;
  }

  :host(:not([dir="rtl"])) .business-lines__item:last-child .business-lines__button {
    border-right: 1px solid #e6e6e6;
  }

  :host([dir="rtl"]) .business-lines__item:last-child .business-lines__button {
    border-left: 1px solid #e6e6e6;
  }

  .business-lines__button:hover {
    background-color: #fafafa;
  }

  .business-lines__button:active {
    background-color: #e6e6e6;
  }
}

.business-lines__button--active {
  border-bottom: 1px solid #e6e6e6;
  color: #3dcd58;
}

@media screen and (min-width: 980px) {
  .business-lines__button--active {
    border-bottom: 2px solid #3dcd58;
    background-color: #fafafa;
  }
}

.business-lines__name-wrapper {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media screen and (min-width: 980px) {
  .business-lines__name-wrapper {
    align-items: flex-start;
    border: 0;
    max-height: 42px;
    margin-top: 8px;
  }
}

.business-lines__button--active .business-lines__name-wrapper {
  border-bottom: none;
}

.business-lines__item:last-child .business-lines__name-wrapper {
  border: none;
}

@media screen and (min-width: 980px) {
  .business-lines__name {
    width: 100%;
    max-height: 60px;
    overflow: hidden;
    padding: 0 12px;
    color: #333333;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
}

.business-lines__button--active .business-lines__name {
  color: inherit;
}

.business-lines__icon--hero {
  color: #3dcd58;
}

@media screen and (max-width: 979px) {
  .business-lines__icon--hero {
    box-sizing: border-box;
    min-width: 56px;
    max-width: 56px;
    min-height: 56px;
    max-height: 56px;
    padding: 16px;
  }
}

@media screen and (min-width: 980px) {
  .business-lines__icon--hero {
    padding: 0;
    font-size: 32px;
    line-height: 32px;
    margin: 12px auto 0;
    align-self: flex-start;
  }
}

.business-lines__icon--opened, .business-lines__icon--closed {
  max-width: 28px;
  min-width: 28px;
  overflow: hidden;
  color: #9fa0a4;
}

:host(:not([dir="rtl"])) .business-lines__icon--opened, :host(:not([dir="rtl"])) .business-lines__icon--closed {
  margin-right: 12px;
}

:host([dir="rtl"]) .business-lines__icon--opened, :host([dir="rtl"]) .business-lines__icon--closed {
  margin-left: 12px;
}

@media screen and (min-width: 980px) {
  .business-lines__icon--opened, .business-lines__icon--closed {
    display: none;
  }
}

.business-lines__icon--opened {
  display: none;
}

.business-lines__button--active .business-lines__icon {
  color: inherit;
}

@media screen and (max-width: 979px) {
  .business-lines__button--active .business-lines__icon--opened {
    display: flex;
  }
}

.business-lines__button--active .business-lines__icon--closed {
  display: none;
}

@media screen and (max-width: 979px) {
  .business-lines__header {
    margin: 0;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: #9fa0a4;
    background-color: #f7f7f7;
  }

  :host(:not([dir="rtl"])) .business-lines__header {
    padding: 12px 0 0 24px;
  }

  :host([dir="rtl"]) .business-lines__header {
    padding: 12px 24px 0 0;
  }
}

.business-lines__link-wrapper {
  display: none;
}

@media screen and (max-width: 979px) {
  .business-lines__link-wrapper {
    display: block;
  }

  :host(:not([dir="rtl"])) .business-lines__link-wrapper {
    padding-left: 24px;
  }

  :host([dir="rtl"]) .business-lines__link-wrapper {
    padding-right: 24px;
  }
}